import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ChildComplete from '../DDRComplete/ChildComplete/index.tsx';
import Layout from '../../components/Layout/Layout';

class ReturningChildComplete extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    if (!this.props.registeredUser) {
      this.props.history.replace('/');
    } else {
      this.props.analytics.trackEvent('Registration Complete Viewed', {
        eventProps: {
          role: 'child'
        }
      });
    }
  }

  render() {
    return (
      <Layout>
        <ChildComplete {...this.props} />
      </Layout>
    );
  }
}

export default ReturningChildComplete;
